export function getDecimalSeparator() {
  return parseFloat((3 / 2).toString()).toLocaleString().substring(1, 2);
}
export default function removeNumberSeparators(value) {
  var decimalSeparator = getDecimalSeparator();
  if (decimalSeparator === '.') {
    return value.replace(/,/g, '');
  }
  if (decimalSeparator === ',') {
    return value.replace(/\./g, '');
  }
  return value;
}